import React, { useEffect, useMemo } from "react";
import Sidebar from "../side-bar/side-bar";
import { MenuItem, Permission } from "../types/menu-item";
import { Outlet } from "react-router-dom";
import "./main-layout.scss";
import { useSelector } from "react-redux";
import { footerItems, menuItems } from "../types/side-bar";
import { useLogin } from "../../../common/hooks/useUser";
import _ from "lodash";
import { SUPER_TENANT } from "../../../utils/constants";

const MainLayout: React.FC = () => {
  const permissions = useSelector(
    (state: any) => state?.session?.userDetails?.roles?.rolePermissions
  );

  const tenantDetails = useLogin();

  const currentUserRoleId = useMemo(() => {
    return tenantDetails?.userDetails?.roles?.id;
  }, [tenantDetails]);

  const currentUserType = tenantDetails?.tenantDetails?.tenantType;


  const filterMenuByPermissions = (
    menuItems: MenuItem[] | undefined,
    permissions: Permission[]
  ): MenuItem[] => {
    if (!menuItems) return [];
    if (!permissions) return menuItems;

    return menuItems.filter((menu) => {
      const module: any = permissions?.find(
        (perm: any) => perm?.resource === menu?.moduleName
      );

      let hasMainMenuPermission: boolean = false;

      // If menu doesn't have a moduleName, allow access (like Dashboard)
      if (!menu.moduleName) {
        hasMainMenuPermission = true;
      }
      // If menu has moduleName, check permissions
      else if (module) {
        // If module exists in permissions, check read access (default to true if scopes not defined)
        hasMainMenuPermission = !module.scopes || module.scopes.read === true;
      }
      else {
        hasMainMenuPermission = false;
      }

      // const hasMainMenuPermission =
      //   !menu.moduleName || module?.permissions?.includes("read") || false;
     
      if (
        (menu?.permissionRole?.length &&
          !menu.permissionRole.includes(currentUserRoleId))
      ) {
        return false;
      }
      if (menu?.onlyShowTOAFP) {
        return currentUserType === SUPER_TENANT && hasMainMenuPermission;
      }
      if (menu.subMenu) {
        menu.subMenu = filterMenuByPermissions(
          menu.subMenu,
          module?.subresources
        );

        return hasMainMenuPermission && menu.subMenu.length > 0;
      }

      return hasMainMenuPermission;
    });
  };

  const filterMenu = _.cloneDeep(menuItems);
  const footerMenu = _.cloneDeep(footerItems);
  const menuFilterItems = filterMenuByPermissions(filterMenu, permissions);
  const footerFilterItems = filterMenuByPermissions(footerMenu, permissions);

  return (
    <div className="main-layout">
      <Sidebar menuItems={menuFilterItems} footerItems={footerFilterItems} />
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
